import React, { Suspense } from 'react';
import './App.css';
// react library for routing
import { Router, Switch, Redirect, BrowserRouter, matchPath } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { history } from './store/history';
import AdminLayout from "layouts/Admin";
import AuthLayout from "layouts/Auth";
import Notification from "components/Extra/Notificaton";
import Loader from "components/Extra/loader";
import 'services/http/intercepter';
import PrivateRoute from "router/PrivateRoutes";
import AuthRoute from "router/AuthRoutes";
import * as storage from 'services/utility/storage';
import { loaderService } from 'services/loader/loader.service';
import appConstant from 'constants/app';
import * as actionType from 'constants/actionType';
import SuspenseFallBack from "components/Extra/SuspenseFallBack";
import CacheBuster from 'CacheBuster';
import * as utils from './services/utility/utils';

class App extends React.Component {

  componentDidMount() {

    this.checkToken();
    loaderService.show();

    let auth = storage.getLocalStorage(appConstant.TOKEN);
    let company = storage.getLocalStorage(appConstant.COMPANY);

    if (auth && auth.token) {

      if (company) {
        store.dispatch({
          type: actionType.LOG_IN_SUCCESS,
          payload: auth
        });

        store.dispatch({
          type: actionType.COMPANY_LOAD_SUCCESS,
          payload: company
        });
      }
      else {
        storage.clearAllCache();
      }

    }

    loaderService.hide();
  }

  checkAndResetCompanyCode = (code) => {
    const companyCode = storage.getSessionStorage(appConstant.CompanyCode);
    if (utils.isNullOrWhiteSpace(companyCode)) {
      storage.clearRestCache();
      this.setTokenStorage(code);
    }
    else {
      if (companyCode !== code) {
        storage.clearRestCache();
        this.setTokenStorage(code);
      }
    }
  }

  checkToken = () => {
    const match = matchPath(history.location.pathname, {
      path: "/admin/redirect/:id/:code"
    });

    if (match && match.params.id && match.params.code) {
      const companyCode = match.params.code;
      let companiesTokens = storage.getLocalStorage(appConstant.TOKENS)
      if (companiesTokens && companiesTokens !== null) {
        let tokens = companiesTokens.filter((item => item.code === companyCode));
        if (tokens.length === 0) {
          storage.clearAllCache();
        }
        else {
          this.checkAndResetCompanyCode(companyCode)
        }
      }
    }
    else {
      const companyCode = storage.getSessionStorage(appConstant.CompanyCode);
      let auth = storage.getLocalStorage(appConstant.TOKEN)
      if (utils.isNullOrWhiteSpace(companyCode)) {
        if (auth && auth.token) {
          this.setTokenStorage(auth.code);
        }
      }
    }
  }

  setTokenStorage = (companyCode) => {
    const companies = storage.getLocalStorage(appConstant.COMPANIES);
    const tokens = storage.getLocalStorage(appConstant.TOKENS);
    if (tokens && tokens !== null && companies && companies !== null) {
      const token = tokens.filter(w => w.code === companyCode);
      const result = companies.filter(w => w.code === companyCode);
      if (result.length > 0) {
        storage.setLocalStorage(appConstant.TOKEN, token[0]);
        storage.setLocalStorage(appConstant.COMPANY, result[0]);
        storage.setSessionStorage(appConstant.CompanyCode, companyCode);
      }
    }
  }


  render() {
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }
          return (
            <Provider store={store} >
              <Suspense fallback={<SuspenseFallBack ></SuspenseFallBack>}>
                <Router basename="/" history={history}>
                  <Notification></Notification>
                  <Loader></Loader>
                  <BrowserRouter>
                    <Switch>
                      {/* <PrivateRoute  path="/admin" render={props => <AdminLayout {...props} />} /> */}
                      <PrivateRoute path="/admin" key="/admin" component={AdminLayout} />;
              <AuthRoute path="/auth" component={AuthLayout} /> ;
              <Redirect from="*" to="auth/login" />;
            </Switch>
                  </BrowserRouter>
                </Router>
              </Suspense>
            </Provider>


          );
        }}
      </CacheBuster>
    );
  }
}

export default App;
